<template>
  <div class="group-title">
    <slot>{{ title }}</slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
.group-title {
  padding-left: 8px;
  margin: 40px 0 24px;
  border-left: 4px solid var(--main-color);
}
</style>
